<template>
  <div>

  <div class="container" style="background-color: #fff; padding-top: 15px;border-left:1px solid #ddd;border-right:1px solid #ddd;margin-bottom:0px;padding-bottom:15px;color:#666;font-size:20px;">

        <div class="row align-items-start no-gutters">
            <div class="col-md-3" style="font-size:20px;">

              <div class="nav flex-column nav-pills nav-side">

                <router-link class="nav-link" :to="{ name: 'account-settings' }">Settings</router-link>
                
                <router-link class="nav-link" :to="{ name: 'account-credits' }">Geofolio <span style="background-color:#84ba45;font-weight:600;color:#fff;padding:0px 3px;border-radius:2px;font-size:16px;position:relative;top:0px;left:0px;">Pro</span> Credits</router-link>


              </div>
            </div>
            <div class="col-md-9" style="padding:15px;padding-left:30px;border-top:1px solid #ddd;">
                  <router-view/>                
            </div>
        </div>
    </div>

  </div>
</template>

<script>
  import MainHeader from '@/components/generic/MainHeader.vue'
  import Footer from '@/components/generic/Footer.vue'

  import VueRouter from 'vue-router'



  //import Account from '@/components/home/user/Account.vue'

  export default {
    name: 'account',
    components: {
      MainHeader, Footer//, Account
    },
    computed: {
        profile() {
            return this.$store.state.profile
        },
        init() {
          return this.$store.state.init
        }
    }
  }
</script>

<style scoped>
div.nav-side a {
  border-radius:0px;
  font-size:16px;
  padding:12px 6px 12px 15px;
  display:block;
  background-color:#fff;
  border-top:1px solid #ddd !important;
}
div.nav-side a.router-link-exact-active {
  background-color:#f5f5f5 !important;
}
</style>
